import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Highlights from './components/Highlights';
import Menu from './components/Menu';
import Plans from './components/Plans';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import OrderModal from './components/OrderModal';
import FloatingWhatsAppButton from './components/FloatingWhatsAppButton';
import { SpeedInsights } from "@vercel/speed-insights/react"
function App() {
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);

  return (
    <div className="App">
      <SpeedInsights/>
      <Header onOpenOrder={() => setIsOrderModalOpen(true)} />
      <Hero onOpenOrder={() => setIsOrderModalOpen(true)} />
      <HowItWorks />
      <Highlights />
      <Menu />
      <Plans onOpenOrder={() => setIsOrderModalOpen(true)} />
      <FAQ />
      <Footer />
      
      <OrderModal 
        isOpen={isOrderModalOpen} 
        onClose={() => setIsOrderModalOpen(false)} 
      />
      
      <FloatingWhatsAppButton />
    </div>
  );
}

export default App;